import React, { Component } from 'react';
import './HeaderTeam.css';

class HeaderVTeam extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const styles = {
            backgroundImage: `url(https://neulionms-a.akamaihd.net/nba/player/v3/nba/site/images/teams/${this.props.team}_p.png)`,
        }
        return (
            <div className="game-away">
                <div className="game-wrapper-logo away-logo">
                    <div className="team-logo" style={styles}>
                    </div>
                </div>
                <div className="team-name">
                    {this.props.name}
                </div>
            </div >
        );
    }
}

export default HeaderVTeam;